import parse from "html-react-parser"
import React from "react"

import {
  darkHeroTitleOptions,
  heroBlueTitleOptions,
  heroTitleOptions,
} from "./heroTitle"
import { postOptions } from "./post"
import { brightSectionTitle, sectionTitleOptions } from "./sectionTitle"
import { standardOptions } from "./standardOptions"

export default function RichText({ stringHtml, option, dark, bigger }) {
  function parseOptions() {
    switch (option) {
      case "heroTitle":
        return heroTitleOptions
      case "heroBlueTitle":
        return heroBlueTitleOptions
      case "darkHeroTitle":
        return darkHeroTitleOptions
      case "sectionTitle":
        return sectionTitleOptions
      case "brightSectionTitle":
        return brightSectionTitle
      case "postOptions":
        return postOptions
      case "standardOptions":
        return standardOptions(dark, bigger)
      default:
        return heroTitleOptions
    }
  }
  return <div>{parse(stringHtml, parseOptions())}</div>
}
